// import node module libraries
import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  Image,
  Nav,
  Tab,
  Button,
  ProgressBar,
  Form,
  Badge,
  Modal
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client/react";
import gql from 'graphql-tag';
import { PaystackButton } from "react-paystack";

// import custom components
import Ratings from "components/marketing/common/ratings/Ratings";
import GKAccordionProgress from "components/marketing/common/accordions/GKAccordionProgress";
import LevelIcon from "components/marketing/common/miscellaneous/LevelIcon";

// import sub components tabs
import ReviewsTab from "components/marketing/pages/courses/course-single/ReviewsTab";
import DescriptionTab from "components/marketing/pages/courses/course-single/DescriptionTab";
import TranscriptTab from "components/marketing/pages/courses/course-single/TranscriptTab";
import FAQTab from "components/marketing/pages/courses/course-single/FAQTab";

import moment from "moment";
import { getTotalRating, numberWithCommas, stripHtml } from "helper/utils";
import VideoPlayer from "components/marketing/common/video/VideoPlayer";
import useAuth from "hooks/useAuth";
import { Notify } from "notiflix";
import { Avatar } from "components/elements/bootstrap/Avatar";

// queries mutations
import { CREATE_FREE_PAYMMENT } from "helper/graphql/mutations";
import { GET_USER_PAID_PACKAGES, GET_COURSE_BY_ID, GET_USER_PAID_COURSES, GET_COURSE_PROGRESS,GET_USER_PUBLIC_PROFILE, GET_USER_DETAILS } from "helper/graphql/queries";
import { REGISTER_USER,LOGIN_USER } from "helper/graphql/mutations";
import ChatTab from "../course-single/ChatTab";
import { set } from "date-fns";
import { getUserGUID, setSession } from "utils/jwt";

// ----------------------------------------------------------------------

const CourseSingle2 = () => {
  const { guid } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isReview = pathname.includes('review');
  const { isAuthenticated, user, login } = useAuth();

  const TABS = !isAuthenticated ? ["Description", "Reviews"] : ["Description", "Reviews", "Chat"];

  const [course, setCourse] = useState(null);
  const [courseProgress, setCourseProgress] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [modules, setModules] = useState([]);
  const [chatInfo, setChatInfo] = useState(null);
  const [isCoursePaid, setCoursePaid] = useState(false);
  const [selectedMode, setSelectedMode] = useState(null);
   const [isEnrolling, setIsEnrolling] = useState(false);


  const [onCreatePayment, { loading: isCreateFreeLoader }] = useMutation(CREATE_FREE_PAYMMENT);
  const [checkIfPaid] = useLazyQuery(GET_USER_PAID_COURSES);
  const [onCheckUserByEmail] = useLazyQuery(GET_USER_PUBLIC_PROFILE);
  const [getUserInfo] = useLazyQuery(GET_USER_DETAILS);
  

  useQuery(GET_COURSE_BY_ID, {
    variables: { guid: guid, userGuid: user?.guid },
    onCompleted: (data) => {
      const _course = data?.allCourses?.edges[0]?.node;
      const _modules = _course?.coursemodulesSet?.edges?.map((item) => item.node);

      setCourse(_course);
      setReviews(_course?.coursereviewsSet?.edges?.map((item) => item.node));
      setModules(_modules);
      setChatInfo(_course?.courseChatGroup);
    },
  });
  
    
  useQuery(GET_COURSE_PROGRESS, {
    variables: {
      userGuid: user?.guid,
      courseGuid: guid,
    },
    skip: !isAuthenticated, // Skip the query if the user is not authenticated
    onCompleted: (data) => {
      setCourseProgress(data?.allCourseProgress?.edges[0]?.node);
    },
  });


  useEffect(() => {
    if (course != null) {
      const mode = (course?.learningMode || course?.learning_mode || "").toLowerCase();
      if (mode === "hybrid") {
        setSelectedMode("online");
      } else if (mode) {
        setSelectedMode(mode);
      }
      isAuthenticated && (
checkIfPaid({
        variables: { userIdGuid: user?.guid, course: course?.id },
        onCompleted: (data) => {
          const _paidPacks = data?.allPackagePayments?.edges?.map((item) => item.node);
          if (_paidPacks.length !== 0) {
            setCoursePaid(true)
          } else {
            setCoursePaid(false)
          }
        },
      })
      )
      
    }
  }, [course]);

  const handleTopicChange = (topic) => {
    // Handle topic change
  };

  const handleCheckout = (price) => {
    onCreatePayment({
      variables: {
        nextPaymentDate: moment().add(1, "M"),
        courseId: course?.guid,
        userId: user?.guid,
        amount: price,
      },
      onCompleted: () => {
        Notify.success("Enrollment Success!");
        setCoursePaid(true);
      },
      onError: (err) => {
        console.log(err);
        Notify.failure("Failed to enroll!");
      },
      refetchQueries: [
        {
          query: GET_USER_PAID_PACKAGES,
          variables: { userIdGuid: user?.guid },
        },
      ],
    });
  };
   const handleQuickCheckout = (price) => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    console.log('storedUser', storedUser);
    // console.log(storedUser);
    onCreatePayment({
      variables: {
        nextPaymentDate: moment().add(1, "M"),
        courseId: course?.guid,
        userId: storedUser?.guid,
        amount: price,
      },
      onCompleted: () => {
        Notify.success("Enrollment Success!");
        setCoursePaid(true);
        setIsEnrolling(false);
        setShowModal(false);
        window.location.reload();
      },
      onError: (err) => {
        console.log(err);
        Notify.failure("Failed to enroll!");
      },
      refetchQueries: [
        {
          query: GET_USER_PAID_PACKAGES,
          variables: { userIdGuid: storedUser?.guid },
        },
      ],
    });
  };

  // const handlePaystackSuccess = (data) => {
  //   handleCheckout(course?.price);
  //   Notify.success("Thank you for your payment");
  // };

  const handlePaystackClose = (data) => {
    Notify.failure("Payment was cancelled");
    window.location.reload();
  };

  useEffect(() => {
    document.body.className = "bg-light";
  });

    const reviewCount = course?.coursereviewsSet?.edges?.map((item) => item.node);
  
    const rating = reviewCount?.length !== 0 ? getTotalRating(reviewCount) : 0;

    // get total registered users by unique email from the pacagepayments set   const reviewCount = course?.coursereviewsSet?.edges?.map((item) => item.node);
    const totalRegisteredAttendees = course?.packagepaymentsSet?.edges
      ?.filter((item) => item.node.course.guid === course?.guid) // Filter by current course
      ?.map((item) => item.node.user.email);
 
    // Count unique emails from the filtered list
    const uniqueAttendeesCount = [...new Set(totalRegisteredAttendees)].length;

    // check if the user is in the attendees list
    const isUserAttendee = totalRegisteredAttendees?.includes(user?.email);

  
  

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    country: 'KENYA', // Default value
    gender: 'Other', // Default value
    isAdmin: false, // Default value
    isHealthcareWorker: false, // Default value
    isOrgAdmin: false, // Default value
    isPatient: true, // Default value
    phoneNumber: '', // Default value
    state: '', // Default value
    isPrivacyPolicyGiven: true, // Default value
    isConsentGiven: true, // Default value
  });
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const [isUserRegistered, setIsUserRegistered] = useState(false);
  const [onRegisterUser] = useMutation(REGISTER_USER);
  const [onLoginUser] = useMutation(LOGIN_USER);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

    function generateRandomPassword() {
    const length = 10;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
    let password = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      password += charset.charAt(Math.floor(Math.random() * n));
    }
    return password;
  }
  // }
  // const handlePaymentSuccess = async () => {
  //   if (!isUserRegistered) {
  //     try {
  //       const password = generateRandomPassword(); // Function to generate a random password
  //       console.log("Generated password:", password);
  //       const registerResponse = await onRegisterUser({
  //         variables: {
  //           ...formData,
  //           password,
  //           country: formData.country,
  //           state: formData.state,
  //           gender: formData.gender,
  //           isAdmin: formData.isAdmin,
  //           isHealthcareWorker: formData.isHealthcareWorker,
  //           isOrgAdmin: formData.isOrgAdmin,
  //           isPatient: formData.isPatient,
  //           phoneNumber: formData.phoneNumber,
  //           isPrivacyPolicyGiven: formData.isPrivacyPolicyGiven,
  //           isConsentGiven: formData.isConsentGiven,
  //         }
  //       });
  //       console.log('User registered:', registerResponse);

  //       const loginResponse = await onLoginUser({
  //         variables: {
  //           username: formData.email,
  //           password
  //         }
  //       });
  //       console.log('User logged in:', loginResponse);
  //       // Save token and update authentication state
  //       const token = loginResponse.data.loginUser.token;

  //       localStorage.setItem("isAuthenticated", true);
  //       localStorage.setItem("accessToken", token);
  //       // Redirect to course content or refresh page
  //       getUserInfo({
  //         variables: { guid: getUserGUID(token) },
  //         onCompleted: (data) => {
  //           localStorage.setItem("user", JSON.stringify(data?.allUsers?.edges[0]?.node || ''));
  //         },
  //       });
  //     } catch (error) {
  //       console.error('Error during registration or login:', error);
  //     }
  //   } else {
  //     try {
  //       const loginResponse = await onLoginUser({
  //         variables: {
  //           username: formData.email,
  //           password: 'defaultPassword' // Assuming a default password for existing users
  //         }
  //       });
  //       console.log('User logged in:', loginResponse);
  //       // Save token and update authentication state
  //       const token = loginResponse.data.loginUser.token;
        
  //       localStorage.setItem("isAuthenticated", true);
  //       localStorage.setItem("accessToken", token);
  //       // Redirect to course content or refresh page
  //       getUserInfo({
  //         variables: { guid: getUserGUID(token) },
  //         onCompleted: (data) => {
  //           localStorage.setItem("user", JSON.stringify(data?.allUsers?.edges[0]?.node || ''));
  //         },
  //       });

  //     } catch (error) {
  //       console.error('Error during login:', error);
  //     }
  //   }
  // };

      const mode = (course?.learningMode || course?.learning_mode || "").toLowerCase();
    const onlinePrice = Number(course?.price) || 0;
    const physicalPrice = Number(course?.physicalPrice ?? course?.physical_price) || 0;
    const isHybrid = mode === "hybrid";
    const currentPrice = isHybrid
      ? (selectedMode === "physical" ? physicalPrice : onlinePrice)
      : (mode === "physical" ? physicalPrice : onlinePrice);


  const handlePaymentSuccess = async () => {
    handleCheckout(currentPrice);
    Notify.success("Payment successful!");
     setShowModal(false);
     window.location.reload();
  };

  const handleFreeEnroll = async () => {
    setIsEnrolling(true);
    handleQuickCheckout(0);
    setTimeout(() => {
      Notify.success("Enrollment Success!");

      // setShowModal(false);
      setIsEnrolling(false);
      
    }, 1500);
   
      // window.location.reload();
  };

  const loginAndBootstrapUser = async (email, password) => {
  const loginResponse = await onLoginUser({
    variables: { username: email, password },
  });
  if(loginResponse.errors)  {
    Notify.failure("Login failed. Please check your credentials.");
  }

  const token = loginResponse.data.loginUser.token;
  setSession(token);
  // login(token)

  localStorage.setItem("isAuthenticated", "true");
  localStorage.setItem("accessToken", token);

  await getUserInfo({
    variables: { guid: getUserGUID(token) },
    onCompleted: (data) => {
      localStorage.setItem(
        "user",
        JSON.stringify(data?.allUsers?.edges[0]?.node || "")
      );
      if(currentPrice > 0){
      setModalStep(2); // payment step
      } else {
        setModalStep(3); // next step after payment
      }
    },
  });
};


const handleCheckEmail = async () => {
  setIsCheckingEmail(true);

  try {
    const { data } = await onCheckUserByEmail({
      variables: { email: formData.email },
    });

    // 🔹 Existing user → ask for password
    if (data?.getUserPublicInfo) {
      setIsUserRegistered(true);
      return; // stay on step 1, show password input
    }

    // 🔹 New user → register + auto-login
    setIsUserRegistered(false);

    const password = generateRandomPassword();

    const registerResponse = await onRegisterUser({
      variables: {
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        password,
        country: formData.country,
        gender: formData.gender,
        isAdmin: formData.isAdmin,
        isHealthcareWorker: formData.isHealthcareWorker,
        isOrgAdmin: formData.isOrgAdmin,
        isPatient: formData.isPatient,
        phoneNumber: formData.phoneNumber,
        state: formData.state,
        isPrivacyPolicyGiven: formData.isPrivacyPolicyGiven,
        isConsentGiven: formData.isConsentGiven,
      },
    });

    if (!registerResponse.data?.createUser?.user) {
      throw new Error("Registration failed");
    }

    await loginAndBootstrapUser(formData.email, password);

  } catch (err) {

    console.error("Error checking email:", err);
  } finally {
    setIsCheckingEmail(false);
  }
};

const handleLoginExistingUser = async () => {
  if (!formData.password) return;

  setIsCheckingEmail(true);

  try {
    await loginAndBootstrapUser(formData.email, formData.password);
  } catch (err) {
    Notify.failure("Login failed. Please check your credentials.");

    console.error("Login failed:", err);
  } finally {
    setIsCheckingEmail(false);
  }
};




  const [modalStep, setModalStep] = useState(1); // Step 1: User details, Step 2: Payment

//   const renderModalContent = () => {
//     if (modalStep === 1) {
//       return (
//         <Form>
//           <Form.Group controlId="formFirstName">
//             <Form.Label>First Name</Form.Label>
//             <Form.Control
//               type="text"
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleInputChange}
//               placeholder="Enter your first name"
//             />
//           </Form.Group>
//           <Form.Group controlId="formLastName">
//             <Form.Label>Last Name</Form.Label>
//             <Form.Control
//               type="text"
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleInputChange}
//               placeholder="Enter your last name"
//             />
//           </Form.Group>
//           <Form.Group controlId="formEmail">
//             <Form.Label>Email</Form.Label>
//             <Form.Control
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleInputChange}
//               placeholder="Enter your email"
//             />
//           </Form.Group>
//           {isUserRegistered && (
//             <Form.Group controlId="formPassword">
//             <Form.Label>Enter Password to proceed</Form.Label>
//             <Form.Control
//               type="password"
//               name="password"
//               value={formData.password}
//               onChange={handleInputChange}
//               placeholder="Enter your password"
//             />
//           </Form.Group>
//           )}
           
//           {/* <Button
//             variant="primary"
//             onClick={handleCheckEmail}
//             disabled={isCheckingEmail}
//           >
//             {isCheckingEmail ? 'Initiating request...' : 'Request'}
//           </Button> */}

//           <Button
//   variant="primary"
//   disabled={isCheckingEmail}
//   onClick={
//     isUserRegistered
//       ? handleLoginExistingUser   // 🔑 login if password is shown
//       : handleCheckEmail          // 🔑 check email otherwise
//   }
// >
//   {isCheckingEmail
//     ? "Processing..."
//     : isUserRegistered
//       ? "Login & Continue"
//       : "Continue"}
// </Button>
//         </Form>
//       );
//     } else if (modalStep === 2) {
//       return (
//         <div>
//           <h5>Proceed to Payment</h5>
//           {currentPrice}
//           {formData.email}

//             <PaystackButton
//                                       className="btn btn-primary btn-lg w-100 enroll-btn"
//                                       email={formData?.email}
//                                       amount={currentPrice * 130 * 100}
//                                       metadata={{
//                                         name: `${formData?.firstName} ${formData?.lastName}`,
//                                         phone: formData?.phone,
//                                       }}
//                                       publicKey={process.env.REACT_APP_PAYSTACK_KEY}
//                                       currency="KES"
//                                       text={
//                                         <>
//                                           <i className="fe fe-credit-card me-2"></i>
//                                           Enroll Now
//                                         </>
//                                       }
//                                       onSuccess={handlePaymentSuccess}
//                                       onClose={handlePaystackClose}
//                                     />
//         </div>
//       );
//     }else if (modalStep === 3) {
//       return (
//         <div>
//           <Button variant="primary" onClick={() => handleFreeEnroll()}>
//             Enroll Now
//           </Button>
//         </div>
//       );
//     }
//   };

const renderModalContent = () => {
  // Step 1: User Registration/Login
  if (modalStep === 1) {
    return (
      <div className="enrollment-step">
        {/* Step Header */}
        <div className="step-header mb-4">
          <div className="step-icon-wrapper">
            <i className="fe fe-user step-icon"></i>
          </div>
          <h4 className="step-title">Welcome!</h4>
          <p className="step-subtitle">
            {isUserRegistered 
              ? "Welcome back! Please enter your password to continue" 
              : "Create your account to enroll in this course"}
          </p>
        </div>

        {/* Form */}
        <Form className="enrollment-form">
          {!isUserRegistered && (
            <Row className="g-3 mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="form-label-modern">
                    First Name <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="input-icon-wrapper">
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      placeholder="John"
                      className="form-control-modern with-icon"
                      required
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="form-label-modern">
                    Last Name <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="input-icon-wrapper">
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder="Doe"
                      className="form-control-modern with-icon"
                      required
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="form-label-modern">
              Email Address <span className="text-danger">*</span>
            </Form.Label>
            <div className="input-icon-wrapper">
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="john.doe@example.com"
                className="form-control-modern with-icon"
                disabled={isUserRegistered}
                required
              />
            </div>
            {isUserRegistered && (
              <Form.Text className="text-muted d-flex align-items-center mt-2">
                <i className="fe fe-check-circle text-success me-2"></i>
                Account found! Please enter your password below.
              </Form.Text>
            )}
          </Form.Group>

          {isUserRegistered && (
            <Form.Group className="mb-4">
              <Form.Label className="form-label-modern">
                Password <span className="text-danger">*</span>
              </Form.Label>
              <div className="input-icon-wrapper">
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password || ''}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  className="form-control-modern with-icon"
                  required
                />
              </div>
              <Form.Text className="text-muted">
                <a href="#" className="text-primary">Forgot password?</a>
              </Form.Text>
            </Form.Group>
          )}

          {!isUserRegistered && (
            <div className="privacy-notice mb-4">
              <i className="fe fe-shield text-success me-2"></i>
              <small className="text-muted">
                By continuing, you agree to our Terms of Service and Privacy Policy. 
                We'll create a secure account for you.
              </small>
            </div>
          )}

          <Button
            variant=""
            className="btn-enrollment-primary w-100"
            disabled={isCheckingEmail || !formData.email || (!isUserRegistered && (!formData.firstName || !formData.lastName))}
            onClick={isUserRegistered ? handleLoginExistingUser : handleCheckEmail}
          >
            {isCheckingEmail ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Processing...
              </>
            ) : isUserRegistered ? (
              <>
                <i className="fe fe-log-in me-2"></i>
                Login & Continue
              </>
            ) : (
              <>
                <i className="fe fe-arrow-right me-2"></i>
                Create Account & Continue
              </>
            )}
          </Button>

          {!isUserRegistered && (
            <div className="already-have-account text-center mt-3">
              <small className="text-muted">
                Already have an account? Just enter your email above.
              </small>
            </div>
          )}
        </Form>

        <style jsx>{`
          .enrollment-step {
            padding: 1rem 0;
          }

          .step-header {
            text-align: center;
          }
             /* Spinner Animation */
        .spinner-border {
          width: 1rem;
          height: 1rem;
          border-width: 2px;
          vertical-align: middle;
        }

          .step-icon-wrapper {
            width: 80px;
            height: 80px;
            margin: 0 auto 1.5rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #F68521 0%, #ff9d4d 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 8px 20px rgba(246, 133, 33, 0.3);
          }

          .step-icon {
            font-size: 2.5rem;
            color: white;
          }

          .step-title {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 0.5rem;
          }

          .step-subtitle {
            font-size: 0.9375rem;
            color: #64748b;
            margin: 0;
            max-width: 400px;
            margin-left: auto;
            margin-right: auto;
          }

          .enrollment-form {
            max-width: 500px;
            margin: 0 auto;
          }

          .form-label-modern {
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 0.5rem;
            font-size: 0.875rem;
          }

          .input-icon-wrapper {
            position: relative;
          }

          .input-icon-left {
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            color: #94a3b8;
            font-size: 1.125rem;
            z-index: 10;
          }

          .form-control-modern {
            border: 2px solid #e2e8f0;
            border-radius: 12px;
            padding: 0.875rem 1rem;
            font-size: 0.9375rem;
            transition: all 0.3s ease;
          }

          .form-control-modern.with-icon {
            padding-left: 3rem;
          }

          .form-control-modern:focus {
            border-color: #F68521;
            box-shadow: 0 0 0 4px rgba(246, 133, 33, 0.1);
          }

          .form-control-modern:disabled {
            background: #f8f9fa;
            cursor: not-allowed;
          }

          .privacy-notice {
            background: rgba(112, 165, 83, 0.05);
            border-left: 4px solid #70a553;
            padding: 1rem;
            border-radius: 8px;
            display: flex;
            align-items: flex-start;
          }

          .btn-enrollment-primary {
            background: linear-gradient(135deg, #F68521 0%, #ff9d4d 100%);
            color: white;
            border: none;
            border-radius: 12px;
            padding: 1rem 2rem;
            font-weight: 700;
            font-size: 1rem;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(246, 133, 33, 0.3);
          }

          .btn-enrollment-primary:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(246, 133, 33, 0.4);
          }

          .btn-enrollment-primary:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .already-have-account {
            padding-top: 1rem;
            border-top: 1px solid #e2e8f0;
          }
        `}</style>
      </div>
    );
  }

  // Step 2: Payment
  else if (modalStep === 2) {
    return (
      <div className="enrollment-step">
        {/* Step Header */}
        <div className="step-header mb-4">
          {/* <div className="step-icon-wrapper payment">
            <i className="fe fe-credit-card step-icon"></i>
          </div> */}
          <h4 className="step-title">Complete Your Enrollment</h4>
          <p className="step-subtitle">
            Secure payment powered by Paystack
          </p>
        </div>

        {/* Course Summary */}
        <div className="payment-summary">
          <div className="summary-header">
            <i className="fe fe-file-text me-2"></i>
            <h6 className="mb-0">Course Summary</h6>
          </div>
          <div className="summary-item">
            <span className="summary-label">Course Title:</span>
            <span className="summary-value">{course?.title}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Learning Mode:</span>
            <span className="summary-value text-capitalize">{selectedMode || mode}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Enrolled as:</span>
            <span className="summary-value">{formData.firstName} {formData.lastName}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Email:</span>
            <span className="summary-value">{formData.email}</span>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item total">
            <span className="summary-label">Total Amount:</span>
            <span className="summary-total">KES {numberWithCommas(currentPrice * 130)}</span>
          </div>
        </div>

        {/* Payment Button */}
        <div className="payment-button-wrapper">
          <PaystackButton
            className="btn-enrollment-payment w-100"
            email={formData?.email}
            amount={currentPrice * 130 * 100}
            metadata={{
              name: `${formData?.firstName} ${formData?.lastName}`,
              phone: formData?.phone || '',
            }}
            publicKey={process.env.REACT_APP_PAYSTACK_KEY}
            currency="KES"
            text={
              <>
                <i className="fe fe-lock me-2"></i>
                Proceed to Secure Payment
              </>
            }
            onSuccess={handlePaymentSuccess}
            onClose={handlePaystackClose}
          />

          <div className="payment-security-badges">
            <div className="security-badge">
              <i className="fe fe-shield text-success"></i>
              <small>Secure Payment</small>
            </div>
            <div className="security-badge">
              <i className="fe fe-lock text-success"></i>
              <small>SSL Encrypted</small>
            </div>
            <div className="security-badge">
              <i className="fe fe-check-circle text-success"></i>
              <small>Verified by Paystack</small>
            </div>
          </div>
        </div>

        <style jsx>{`
          .step-icon-wrapper.payment {
            background: linear-gradient(135deg, #1d9eb0 0%, #3fc1d3 100%);
            box-shadow: 0 8px 20px rgba(29, 158, 176, 0.3);
          }

          .payment-summary {
            background: white;
            border: 2px solid #e2e8f0;
            border-radius: 16px;
            padding: 1.5rem;
            margin-bottom: 2rem;
          }

          .summary-header {
            display: flex;
            align-items: center;
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: 2px solid #f1f5f9;
            color: #1e293b;
            font-weight: 700;
          }

          .summary-item {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0.75rem 0;
            gap: 1rem;
          }

          .summary-label {
            font-size: 0.875rem;
            color: #64748b;
            font-weight: 500;
            flex-shrink: 0;
          }

          .summary-value {
            font-size: 0.875rem;
            color: #1e293b;
            font-weight: 600;
            text-align: right;
          }

          .summary-divider {
            height: 1px;
            background: #e2e8f0;
            margin: 1rem 0;
          }

          .summary-item.total {
            padding: 1rem 0 0;
            border-top: 2px solid #f1f5f9;
          }

          .summary-total {
            font-size: 1.5rem;
            font-weight: 800;
            color: #F68521;
          }

          .payment-button-wrapper {
            max-width: 500px;
            margin: 0 auto;
          }

          .btn-enrollment-payment {
            background: linear-gradient(135deg, #1d9eb0 0%, #3fc1d3 100%) !important;
            color: white !important;
            border: none !important;
            border-radius: 12px !important;
            padding: 1rem 2rem !important;
            font-weight: 700 !important;
            font-size: 1rem !important;
            transition: all 0.3s ease !important;
            box-shadow: 0 4px 12px rgba(29, 158, 176, 0.3) !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .btn-enrollment-payment:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(29, 158, 176, 0.4) !important;
          }

          .payment-security-badges {
            display: flex;
            justify-content: center;
            gap: 1.5rem;
            margin-top: 1.5rem;
            padding-top: 1.5rem;
            border-top: 1px solid #e2e8f0;
          }

          .security-badge {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.5rem;
            color: #64748b;
          }

          .security-badge i {
            font-size: 1.5rem;
          }

          .security-badge small {
            font-size: 0.75rem;
            font-weight: 600;
          }
        `}</style>
      </div>
    );
  }

  // Step 3: Free Enrollment
  else if (modalStep === 3) {
    return (
      <div className="enrollment-step">
        {/* Step Header */}
        <div className="step-header mb-4">
          {/* <div className="step-icon-wrapper success">
            <i className="fe fe-check-circle step-icon"></i>
          </div> */}
          <h4 className="step-title">You're Almost There!</h4>
          <p className="step-subtitle">
            Click the button below to complete your free enrollment
          </p>
        </div>

        {/* Course Summary */}
        <div className="free-enrollment-summary">
          <div className="summary-card">
            <div className="free-badge-large">
              <i className="fe fe-gift me-2"></i>
              FREE COURSE
            </div>
            <div className="course-info">
              <h5 className="course-name">{course?.title}</h5>
              <div className="enrollment-details">
                <div className="detail-item">
                  <i className="fe fe-user"></i>
                  <span>{formData.firstName} {formData.lastName}</span>
                </div>
                <div className="detail-item">
                  <i className="fe fe-mail"></i>
                  <span>{formData.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enrollment Button */}
        <div className="enrollment-button-wrapper">
          <Button 
            variant="" 
            className="btn-enrollment-success w-100"
            onClick={handleFreeEnroll}
            // onClick={handleEnrollWithLoading}
            disabled={isEnrolling}
          >
            {isEnrolling ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Processing Enrollment...
            </>
          ) : (
            <>
              <i className="fe fe-check-circle me-2"></i>
              Complete Free Enrollment
            </>
          )}
          </Button>

          <div className="enrollment-benefits">
            <p className="benefits-title">What you'll get:</p>
            <ul className="benefits-list">
              <li>
                <i className="fe fe-check text-success"></i>
                Full access to all course materials
              </li>
              <li>
                <i className="fe fe-check text-success"></i>
                Lifetime access to course content
              </li>
            </ul>
          </div>
        </div>

        <style jsx>{`
          .step-icon-wrapper.success {
            background: linear-gradient(135deg, #70a553 0%, #8bc86f 100%);
            box-shadow: 0 8px 20px rgba(112, 165, 83, 0.3);
          }

          .free-enrollment-summary {
            margin-bottom: 2rem;
          }

          .summary-card {
            background: linear-gradient(135deg, rgba(112, 165, 83, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%);
            border: 2px solid rgba(112, 165, 83, 0.2);
            border-radius: 16px;
            padding: 2rem;
            text-align: center;
          }

          .free-badge-large {
            background: linear-gradient(135deg, #70a553 0%, #8bc86f 100%);
            color: white;
            padding: 0.75rem 1.5rem;
            border-radius: 12px;
            font-size: 1.125rem;
            font-weight: 800;
            letter-spacing: 1px;
            display: inline-flex;
            align-items: center;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 12px rgba(112, 165, 83, 0.3);
          }

          .course-info {
            margin-top: 1rem;
          }

          .course-name {
            font-size: 1.25rem;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 1rem;
          }

          .enrollment-details {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            align-items: center;
          }

          .detail-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.9375rem;
            color: #64748b;
          }

          .detail-item i {
            color: #94a3b8;
          }

          .enrollment-button-wrapper {
            max-width: 500px;
            margin: 0 auto;
          }

          .btn-enrollment-success {
            background: linear-gradient(135deg, #70a553 0%, #8bc86f 100%);
            color: white;
            border: none;
            border-radius: 12px;
            padding: 1rem 2rem;
            font-weight: 700;
            font-size: 1rem;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(112, 165, 83, 0.3);
          }

          .btn-enrollment-success:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(112, 165, 83, 0.4);
          }

          .enrollment-benefits {
            margin-top: 2rem;
            padding-top: 2rem;
            border-top: 1px solid #e2e8f0;
          }

          .benefits-title {
            font-size: 0.875rem;
            font-weight: 700;
            color: #1e293b;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 1rem;
            text-align: center;
          }

          .benefits-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .benefits-list li {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 0.5rem 0;
            font-size: 0.9375rem;
            color: #475569;
          }

          .benefits-list i {
            font-size: 1.125rem;
            flex-shrink: 0;
          }
        `}</style>
      </div>
    );
  }
};

  return (
    <Fragment>
      {/* Hero Section with Side-by-Side Layout */}
      <section className="course-hero-gradient py-5 pt-lg-12">
        <Container>
          <Row className="g-4 g-lg-5 align-items-center">
            {/* Left Column - Course Poster */}
            <Col lg={5} md={12}>
              <div className="course-poster-wrapper">
                {course?.introVideo?.length !== 0 ? (
                  <div className="video-wrapper">
                    <VideoPlayer
                      title={course?.title || "Course"}
                      video={course?.introVideo[0]}
                    />
                  </div>
                ) : (
                  <div className="poster-image-container">
                    <Image
                      src={course?.introImage?.[0]}
                      fluid
                      className="poster-image"
                      alt={course?.title}
                      onError={(e) => {
                        e.target.src = '/assets/images/course/course-default.jpg';
                      }}
                    />
                    {/* Overlay Badge */}
                    {/* <div className="poster-overlay">
                      <Badge bg="" className="category-badge-large">
                        {course?.category?.name || "Course"}
                      </Badge>
                    </div> */}
                  </div>
                )}
              </div>
            </Col>

            {/* Right Column - Course Details */}
            <Col lg={7} md={12}>
              <div className="course-details-hero">
                {/* Breadcrumb / Category */}
                <div className="d-flex align-items-center gap-2 mb-3">
                  <Badge bg="" className="category-badge">
                    Mode:{" "}
                    <i className="fe fe-folder me-1"></i>
                    {course?.learningMode || "Online"}
                  </Badge>
                  {/* {course?.dificultyLevel && ( */}
                    <Badge bg="" className="level-badge">
                      Level:{" "}
                      <LevelIcon level={course?.dificultyLevel || "EASY"} />
                      <span className="ms-1">{course?.dificultyLevel || "EASY"}</span>
                    </Badge>
                  {/* )} */}
                </div>

                {/* Course Title */}
                <h1 className="hero-title mb-3">{course?.title}</h1>

                {/* Course Subtitle/Description */}
                <p className="hero-description mb-4">
                    {stripHtml(course?.description).length > 100
                    ? `${stripHtml(course?.description).substring(0, 410)}...`
                    : stripHtml(course?.description)}
                </p>
                {/* <p
                  className="hero-description mb-4"
                  dangerouslySetInnerHTML={{ __html: course.description }}
                /> */}

                {/* Stats Row */}
                <div className="stats-row mb-4">
                  <div className="stat-badge">
                    <i className="fe fe-star text-warning"></i>
                    <span className="ms-1">
                      <strong>{rating}</strong> ({reviewCount?.length || 0} reviews)
                    </span>
                  </div>
                  <div className="stat-badge">
                    <i className="fe fe-users"></i>
                    <span className="ms-1">
                      <strong>{numberWithCommas(uniqueAttendeesCount || 0)}</strong> students
                    </span>
                  </div>
                  <div className="stat-badge">
                    <i className="fe fe-clock"></i>
                    <span className="ms-1">
                      {course?.duration || "Self-paced"}
                    </span>
                  </div>
                </div>

                {/* Date Badge */}
                <div className="date-info mb-4">
                  <i className="fe fe-calendar me-2"></i>
                  <span>
                    <strong>Course Dates:</strong> {moment(course?.courseStartDate).format("MMM DD, YYYY")} - {moment(course?.courseEndDate).format("MMM DD, YYYY")}
                  </span>
                </div>

                {/* Progress Bar for Enrolled Students */}
                {isCoursePaid && (
                  <div className="progress-card mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="progress-label">
                        <i className="fe fe-trending-up me-2"></i>
                        Your Progress
                      </span>
                      <span className="progress-percentage">
                        {courseProgress?.courseProgress ? parseFloat(courseProgress?.courseProgress).toFixed(0) : 0}%
                      </span>
                    </div>
                    <ProgressBar
                      variant="info"
                      now={courseProgress?.courseProgress || 0}
                      className="modern-progress"
                    />
                  </div>
                )}

                {/* Instructor Info */}
                <div className="instructor-card">
                  <div className="d-flex align-items-center">
                    <Avatar
                      size="lg"
                      className="rounded-circle"
                      type={course?.creator?.image ? "image" : "initial"}
                      src={course?.creator?.image}
                      alt={course?.creator?.firstName}
                      name={`${course?.creator?.firstName} ${course?.creator?.lastName}`}
                    />
                    <div className="ms-3">
                      <div className="instructor-label">Instructor</div>
                      <h6 className="instructor-name mb-0">
                        {`${course?.creator?.firstName} ${course?.creator?.lastName}`}
                      </h6>
                      <p className="instructor-title mb-0">
                        {course?.creator?.title || course?.creator?.email}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Main Content */}
      <section className="py-5">
        <Container>
          <Row className="g-4">
            {/* Left Column - Course Info */}
            <Col xl={8} lg={12}>
              {/* Tabs Section */}
              <Tab.Container defaultActiveKey="description">
                <Card className="tabs-card">
                  <Card.Header className="border-0 p-0">
                    <Nav className="modern-nav-tabs">
                      {TABS.map((item, index) => (
                        <Nav.Item key={index}>
                          <Nav.Link
                            eventKey={item.toLowerCase()}
                            className="nav-tab-item"
                          >
                            {item === "Description" && <i className="fe fe-file-text me-2"></i>}
                            {item === "Reviews" && <i className="fe fe-message-square me-2"></i>}
                            {item === "Chat" && <i className="fe fe-message-circle me-2"></i>}
                            {item}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Card.Header>

                  <Card.Body className="p-4 p-lg-5">
                    <Tab.Content>
                      <Tab.Pane eventKey="description">
                        <DescriptionTab course={course} isCoursePaid={isCoursePaid} user={user} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="reviews">
                        <ReviewsTab
                          reviews={reviews}
                          course={course}
                          user={user}
                          isAuthenticated={isAuthenticated}
                          isEnrolled={isUserAttendee}
                          updateReviews={(review) => setReviews([...reviews, review])}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="transcript">
                        <TranscriptTab />
                      </Tab.Pane>
                      <Tab.Pane eventKey="faq">
                        <FAQTab />
                      </Tab.Pane>
                      <Tab.Pane eventKey="chat">
                        {isAuthenticated ? (
                          isUserAttendee ? <ChatTab chatInfo={chatInfo} /> : <div className="text-center py-4">
                            You must be registered for this course to access the chat.
                          </div>
                        ) : (
                          <div className="text-center py-4">
                            Please log in to access the chat.
                          </div>
                        )}

                        {/* {isAuthenticated  && isUserAttendee && <ChatTab chatInfo={chatInfo} />} */}
                      </Tab.Pane>
                    </Tab.Content>
                  </Card.Body>
                </Card>
              </Tab.Container>
            </Col>

            {/* Right Column - Sidebar */}
            <Col xl={4} lg={12}>
              <div className="sticky-sidebar">
                {isCoursePaid ? (
                  /* Course Modules for Enrolled Students */
                  <Card className="modules-card">
                    <Card.Header className="bg-white border-bottom">
                      <h5 className="mb-0">
                        <i className="fe fe-list me-2"></i>
                        Course Content
                      </h5>
                    </Card.Header>
                    <GKAccordionProgress
                      accordionItems={modules}
                      onSelected={handleTopicChange}
                      courseProgress={courseProgress}
                      isReview={isReview}
                    />
                  </Card>
                ) : (
                  /* Pricing Card for Non-Enrolled */
                  <Card className="pricing-card">
                    <Card.Body className="p-4">
                      {(() => {
                        const getModeStyles = (m) => {
                          if (m === "online") return { bg: "rgba(29, 158, 176, 0.1)", text: "#1d9eb0", icon: "fe-monitor", label: "Online Learning" };
                          if (m === "physical") return { bg: "rgba(100, 116, 139, 0.1)", text: "#64748b", icon: "fe-map-pin", label: "Physical Attendance" };
                          if (m === "hybrid") return { bg: "rgba(246, 133, 33, 0.1)", text: "#F68521", icon: "fe-layers", label: "Hybrid Mode" };
                          return null;
                        };

                        const modeStyles = getModeStyles(isHybrid ? selectedMode : mode);

                        return (
                          <>
                            {/* Price Display */}
                            <div className="price-section mb-4">
                              {currentPrice === 0 ? (
                                <div className="free-badge-large">
                                  <i className="fe fe-gift me-2"></i>
                                  FREE COURSE
                                </div>
                              ) : (
                                <div className="price-display">
                                  <div className="price-wrapper">
                                    <span className="currency">KES</span>
                                    <span className="amount">{numberWithCommas(currentPrice * 130)}</span>
                                  </div>
                                  <div className="price-note">
                                    <i className="fe fe-info me-1"></i>
                                    One-time payment
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Learning Mode Badge */}
                            {modeStyles && (
                              <div className="mode-badge-wrapper mb-4">
                                <div 
                                  className="mode-badge-large" 
                                  style={{
                                    background: modeStyles.bg,
                                    color: modeStyles.text
                                  }}
                                >
                                  <i className={`fe ${modeStyles.icon} me-2`}></i>
                                  {modeStyles.label}
                                </div>
                              </div>
                            )}

                              {/* Hybrid Mode Selector */}
                                {isHybrid && currentPrice > 0 && (
                                  <Form.Group className="mb-4">
                                    <Form.Label className="fw-semibold mb-2">
                                      <i className="fe fe-target me-2"></i>
                                      Select Your Learning Mode
                                    </Form.Label>
                                    <Form.Select
                                      value={selectedMode || "online"}
                                      onChange={(e) => setSelectedMode(e.target.value)}
                                      className="modern-select"
                                    >
                                      <option value="online">
                                        💻 Online - KES {numberWithCommas(onlinePrice * 130)}
                                      </option>
                                      <option value="physical">
                                        🏢 Physical - KES {numberWithCommas(physicalPrice * 130)}
                                      </option>
                                    </Form.Select>
                                  </Form.Group>
                                )}

                            {!isAuthenticated ? (
                              <div className="text-center py-4">
                                <i className="fe fe-lock" style={{fontSize: "2.5rem", color: "#cbd5e1", marginBottom: "1rem"}}></i>
                                <p className="text-muted mb-3">
                                  Please provide your details to enroll in this course
                                </p>
                                <Button
                                  variant="primary"
                                  size="lg"
                                  className="w-100"
                                  onClick={() => setShowModal(true)}
                                >
                                  Enroll Now
                                </Button>

                                <Modal 
                                  show={showModal} 
                                  onHide={() => setShowModal(false)}
                                  centered
                                  size="lg"
                                  className="enrollment-modal"
                                >
                                  <Modal.Header closeButton className="enrollment-modal-header">
                                    {/* Progress Indicator */}
                                    <div className="enrollment-progress-container">
                                      <div className="enrollment-progress-steps">
                                        <div className={`progress-step ${modalStep >= 1 ? 'active' : ''} ${modalStep > 1 ? 'completed' : ''}`}>
                                          <div className="progress-step-circle">
                                            {modalStep > 1 ? <i className="fe fe-check"></i> : '1'}
                                          </div>
                                          <span className="progress-step-label">Account</span>
                                        </div>
                                        <div className="progress-line"></div>
                                        <div className={`progress-step ${modalStep >= 2 ? 'active' : ''} ${modalStep > 2 ? 'completed' : ''}`}>
                                          <div className="progress-step-circle">
                                            {modalStep > 2 ? <i className="fe fe-check"></i> : '2'}
                                          </div>
                                          <span className="progress-step-label">{currentPrice > 0 ? 'Payment' : 'Confirm'}</span>
                                        </div>
                                        {currentPrice === 0 && (
                                          <>
                                            <div className="progress-line"></div>
                                            <div className={`progress-step ${modalStep >= 3 ? 'active' : ''}`}>
                                              <div className="progress-step-circle">3</div>
                                              <span className="progress-step-label">Enroll</span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </Modal.Header>
                                  
                                  <Modal.Body className="enrollment-modal-body">
                                    {renderModalContent()}
                                  </Modal.Body>

                                  <style jsx>{`
                                    /* Modal Styling */
                                    .enrollment-modal .modal-content {
                                      border: none;
                                      border-radius: 24px;
                                      overflow: hidden;
                                      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
                                    }

                                    .enrollment-modal-header {
                                      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                                      border: none;
                                      padding: 2rem 2rem 1.5rem;
                                    }

                                    .enrollment-modal-header .btn-close {
                                      font-size: 1.5rem;
                                    }

                                    /* Progress Steps */
                                    .enrollment-progress-container {
                                      width: 100%;
                                    }

                                    .enrollment-progress-steps {
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      gap: 1rem;
                                      max-width: 600px;
                                      margin: 0 auto;
                                    }

                                    .progress-step {
                                      display: flex;
                                      flex-direction: column;
                                      align-items: center;
                                      gap: 0.5rem;
                                      flex: 0 0 auto;
                                    }

                                    .progress-step-circle {
                                      width: 48px;
                                      height: 48px;
                                      border-radius: 50%;
                                      background: #e2e8f0;
                                      color: #94a3b8;
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      font-weight: 700;
                                      font-size: 1.125rem;
                                      transition: all 0.3s ease;
                                      border: 3px solid #e2e8f0;
                                    }

                                    .progress-step.active .progress-step-circle {
                                      background: linear-gradient(135deg, #F68521 0%, #ff9d4d 100%);
                                      color: white;
                                      border-color: #F68521;
                                      box-shadow: 0 4px 12px rgba(246, 133, 33, 0.3);
                                    }

                                    .progress-step.completed .progress-step-circle {
                                      background: linear-gradient(135deg, #70a553 0%, #8bc86f 100%);
                                      color: white;
                                      border-color: #70a553;
                                    }

                                    .progress-step-label {
                                      font-size: 0.75rem;
                                      font-weight: 600;
                                      color: #94a3b8;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                      white-space: nowrap;
                                    }

                                    .progress-step.active .progress-step-label {
                                      color: #F68521;
                                    }

                                    .progress-step.completed .progress-step-label {
                                      color: #70a553;
                                    }

                                    .progress-line {
                                      flex: 1;
                                      height: 3px;
                                      background: #e2e8f0;
                                      border-radius: 3px;
                                      min-width: 40px;
                                    }

                                    .enrollment-modal-body {
                                      padding: 2rem 2.5rem 2.5rem;
                                    }

                                    /* Responsive */
                                    @media (max-width: 768px) {
                                      .enrollment-modal-header {
                                        padding: 1.5rem 1rem 1rem;
                                      }

                                      .enrollment-modal-body {
                                        padding: 1.5rem;
                                      }

                                      .enrollment-progress-steps {
                                        gap: 0.5rem;
                                      }

                                      .progress-step-circle {
                                        width: 40px;
                                        height: 40px;
                                        font-size: 1rem;
                                      }

                                      .progress-step-label {
                                        font-size: 0.625rem;
                                      }

                                      .progress-line {
                                        min-width: 20px;
                                      }
                                    }
                                  `}</style>
                                </Modal>
                              </div>
                            ) : (
                              <>
                                {/* Hybrid Mode Selector */}
                                {/* {isHybrid && currentPrice > 0 && (
                                  <Form.Group className="mb-4">
                                    <Form.Label className="fw-semibold mb-2">
                                      <i className="fe fe-target me-2"></i>
                                      Select Your Learning Mode
                                    </Form.Label>
                                    <Form.Select
                                      value={selectedMode || "online"}
                                      onChange={(e) => setSelectedMode(e.target.value)}
                                      className="modern-select"
                                    >
                                      <option value="online">
                                        💻 Online - KES {numberWithCommas(onlinePrice * 130)}
                                      </option>
                                      <option value="physical">
                                        🏢 Physical - KES {numberWithCommas(physicalPrice * 130)}
                                      </option>
                                    </Form.Select>
                                  </Form.Group>
                                )} */}

                                {/* Enrollment Button */}
                                <div className="enrollment-section">
                                  {currentPrice === 0 ? (
                                    <Button
                                      variant="primary"
                                      size="lg"
                                      className="w-100 enroll-btn"
                                      onClick={() => handleCheckout(0)}
                                      disabled={isCreateFreeLoader}
                                    >
                                      {isCreateFreeLoader ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2"></span>
                                          Processing...
                                        </>
                                      ) : (
                                        <>
                                          <i className="fe fe-check-circle me-2"></i>
                                          Enroll for Free
                                        </>
                                      )}
                                    </Button>
                                  ) : (
                                    <PaystackButton
                                      className="btn btn-primary btn-lg w-100 enroll-btn"
                                      email={user?.email}
                                      amount={currentPrice * 130 * 100}
                                      metadata={{
                                        name: `${user?.firstName} ${user?.lastName}`,
                                        phone: user?.phone,
                                      }}
                                      publicKey={process.env.REACT_APP_PAYSTACK_KEY}
                                      currency="KES"
                                      text={
                                        <>
                                          <i className="fe fe-credit-card me-2"></i>
                                          Enroll Now
                                        </>
                                      }
                                      onSuccess={handlePaymentSuccess}
                                      onClose={handlePaystackClose}
                                    />
                                  )}
                                </div>

                                {/* Course Includes */}
                                <div className="course-includes mt-4 pt-4 border-top">
                                  <h6 className="mb-3 fw-semibold">This course might include:</h6>
                                  <ul className="includes-list">
                                    <li>
                                      <i className="fe fe-video text-primary"></i>
                                      <span>Video lectures</span>
                                    </li>
                                    <li>
                                      <i className="fe fe-file-text text-primary"></i>
                                      <span>Downloadable resources</span>
                                    </li>
                                    <li>
                                      <i className="fe fe-award text-primary"></i>
                                      <span>Certificate of completion</span>
                                    </li>
                                    <li>
                                      <i className="fe fe-smartphone text-primary"></i>
                                      <span>Mobile access</span>
                                    </li>
                                    <li>
                                      <i className="fe fe-message-circle text-primary"></i>
                                      <span>Discussion forum</span>
                                    </li>
                                  </ul>
                                </div>
                              </>
                            )}
                          </>
                        );
                      })()}
                    </Card.Body>
                  </Card>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <style jsx>{`
        /* Hero Gradient Background */
        .course-hero-gradient {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          position: relative;
        }

        .course-hero-gradient::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23F68521' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          opacity: 0.4;
          pointer-events: none;
        }

        /* Poster Wrapper */
        .course-poster-wrapper {
          position: relative;
          z-index: 1;
        }

        .poster-image-container {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          background: white;
          padding: 8px;
        }

        .poster-image {
          width: 100%;
          height: auto;
          border-radius: 16px;
          display: block;
        }

        .poster-overlay {
          position: absolute;
          top: 20px;
          left: 20px;
          z-index: 2;
        }

        .category-badge-large {
          background: rgba(246, 133, 33, 0.95) !important;
          color: white !important;
          padding: 10px 20px;
          border-radius: 12px;
          font-size: 0.875rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 12px rgba(246, 133, 33, 0.3);
        }

        .video-wrapper {
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        /* Course Details Hero */
        .course-details-hero {
          position: relative;
          z-index: 1;
        }

        .category-badge {
  background: #F68521 !important;
  color: white !important;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(246, 133, 33, 0.3);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

        .level-badge {
  background: #1d9eb0 !important;
  color: white !important;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(29, 158, 176, 0.3);
  display: flex;
  text-transform: uppercase;
  align-items: center;
  gap: 0.5rem;
}

        .hero-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: #1e293b;
          line-height: 1.2;
        }

        .hero-description {
          font-size: 1.125rem;
          line-height: 1.7;
          color: #475569;
        }

        /* Stats Row */
        .stats-row {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
        }

        .stat-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1rem;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          font-size: 0.9375rem;
          color: #475569;
        }

        .stat-badge i {
          font-size: 1.125rem;
        }

        /* Date Info */
        .date-info {
          display: flex;
          align-items: center;
          padding: 1rem 1.25rem;
          background: rgba(29, 158, 176, 0.05);
          border-left: 4px solid #1d9eb0;
          border-radius: 12px;
          font-size: 0.9375rem;
          color: #475569;
        }

        /* Progress Card */
        .progress-card {
          padding: 1.25rem;
          background: white;
          border-radius: 16px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .progress-label {
          font-weight: 600;
          color: #1e293b;
          font-size: 0.9375rem;
        }

        .progress-percentage {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1d9eb0;
        }

        .modern-progress {
          height: 10px !important;
          border-radius: 10px;
          background-color: #e2e8f0;
        }

        .modern-progress .progress-bar {
          border-radius: 10px;
          background: linear-gradient(90deg, #1d9eb0 0%, #F68521 100%);
        }

        /* Instructor Card */
        .instructor-card {
          padding: 1.25rem;
          background: white;
          border-radius: 16px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .instructor-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #94a3b8;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .instructor-name {
          font-size: 1.0625rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.25rem;
        }

        .instructor-title {
          font-size: 0.875rem;
          color: #64748b;
        }

        /* Modern Nav Tabs */
        .modern-nav-tabs {
  border-bottom: 2px solid #e2e8f0;
  padding: 0 1rem;
  gap: 0.5rem;
  background: #f8fafc;
}

        .nav-tab-item {
  border: none !important;
  color: #475569 !important;
  font-weight: 700 !important;
  padding: 1rem 1.5rem !important;
  border-bottom: 4px solid transparent !important;
  transition: all 0.3s ease !important;
  display: flex;
  align-items: center;
  font-size: 1rem !important;
  background: transparent !important;
}

        .nav-tab-item:hover {
          color: #F68521 !important;
          background: transparent !important;
        }

        .nav-tab-item.active {
  color: #F68521 !important;
  border-bottom-color: #F68521 !important;
  background: white !important;
}
        /* Tabs Card */
        .tabs-card {
  border: 2px solid #f1f5f9;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

        /* Sticky Sidebar */
        .sticky-sidebar {
          position: sticky;
          top: 100px;
        }

        /* Pricing Card */
        .pricing-card {
          border: none;
          border-radius: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        /* Price Display */
        .price-section {
          text-align: center;
        }

        .free-badge-large {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          padding: 1.25rem;
          border-radius: 16px;
          font-size: 1.25rem;
          font-weight: 800;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .price-display {
          background: linear-gradient(135deg, #F68521 0%, #1d9eb0 100%);
          padding: 2rem;
          border-radius: 16px;
          color: white;
        }

        .price-wrapper {
          display: flex;
          align-items: baseline;
          justify-content: center;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
        }

        .currency {
          font-size: 1.25rem;
          font-weight: 600;
          opacity: 0.9;
        }

        .amount {
          font-size: 2.5rem;
          font-weight: 800;
          line-height: 1;
        }

        .price-note {
          font-size: 0.875rem;
          opacity: 0.95;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.25rem;
        }

        /* Mode Badge */
        .mode-badge-large {
          padding: 1rem 1.25rem;
          border-radius: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9375rem;
        }

        /* Modern Select */
        .modern-select {
          padding: 0.875rem 1rem;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .modern-select:focus {
          border-color: #F68521;
          box-shadow: 0 0 0 3px rgba(246, 133, 33, 0.1);
        }

        /* Enroll Button */
        .enroll-btn {
          padding: 1rem 2rem;
          font-size: 1.125rem;
          font-weight: 700;
          border-radius: 12px;
          border: none;
          background: linear-gradient(135deg, #F68521 0%, #1d9eb0 100%);
          transition: all 0.3s ease;
        }

        .enroll-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(246, 133, 33, 0.3);
        }

        /* Course Includes */
        .course-includes h6 {
          color: #1e293b;
        }

        .includes-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .includes-list li {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .includes-list li:last-child {
          border-bottom: none;
        }

        .includes-list i {
          font-size: 1.125rem;
        }

        .includes-list span {
          color: #475569;
          font-size: 0.9375rem;
          font-weight: 500;
        }

        /* Modules Card */
        .modules-card {
          border: none;
          border-radius: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .modules-card .card-header {
          border-radius: 20px 20px 0 0;
          padding: 1.25rem 1.5rem;
        }

        .modules-card h5 {
          color: #1e293b;
          font-weight: 700;
        }

        /* Responsive */
        @media (max-width: 1199px) {
          .sticky-sidebar {
            position: static;
            margin-top: 2rem;
          }
        }

        @media (max-width: 991px) {
          .hero-title {
            font-size: 2rem;
          }

          .course-poster-wrapper {
            margin-bottom: 2rem;
          }

          .poster-image {
            max-width: 400px;
            margin: 0 auto;
          }
        }

        @media (max-width: 768px) {
          .hero-title {
            font-size: 1.75rem;
          }

          .hero-description {
            font-size: 1rem;
          }

          .stats-row {
            gap: 0.75rem;
          }

          .stat-badge {
            font-size: 0.8125rem;
            padding: 0.625rem 0.875rem;
          }

          .amount {
            font-size: 2rem;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default CourseSingle2;